import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { parseFeedSearch } from '~portal/data';
import { isStandalone, logger } from '~portal/lib';
import { UpdatesListing } from './-feeds/UpdatesListing';

/**
 * @desc The updates listing behind Home's "Recent updates — See more…" (UI round 3, H2-310). The page
 * number lives in the URL (`parseFeedSearch`), so a page can be shared or bookmarked. Platform-only:
 * the standalone build is the chat app alone, so it redirects to a new chat like the other
 * platform pages.
 */
export const Route = createFileRoute('/_protected/updates')({
  beforeLoad: () => {
    if (isStandalone) {
      throw redirect({ to: '/chat/$conversationId', params: { conversationId: 'new' } });
    }
  },
  validateSearch: parseFeedSearch,
  component: UpdatesPage,
});

function UpdatesPage() {
  const { page = 1 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onPage = (next: number) => {
    navigate({ search: parseFeedSearch({ page: next }) }).catch((err) => {
      logger.error('[Updates] Navigation failed', {
        error: err instanceof Error ? err.message : String(err),
      });
    });
  };

  return <UpdatesListing page={page} onPage={onPage} />;
}
